import { CxEvent } from '@spartacus/core'
import { MbConstants } from '../../../../shared/mb-constants'

export class FooterNavigationEvent extends CxEvent {

  static readonly type = MbConstants.NAVIGATION
  event = MbConstants.NAVIGATION
  eventCategory: string = MbConstants.UNDEFINED
  eventAction: string = MbConstants.UNDEFINED

  constructor (eventCategory: string, eventAction: string) {
    super()
    this.eventAction = eventAction || MbConstants.UNDEFINED
    this.eventCategory = eventCategory || MbConstants.UNDEFINED
  }
}
